import { render, staticRenderFns } from "./BaseDatepicker.vue?vue&type=template&id=0fca9670&scoped=true&"
import script from "./BaseDatepicker.vue?vue&type=script&lang=js&"
export * from "./BaseDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca9670",
  null
  
)

export default component.exports